import Footer from '@/ui/Footer';
import * as Styled from './styled';

type LayoutProps = React.HTMLProps<HTMLDivElement> & {
  children: React.ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ children, ...rest }) => {
  return (
    <Styled.Layout {...rest}>
      <Styled.LayoutContent>{children}</Styled.LayoutContent>
      <Footer />
    </Styled.Layout>
  );
};

export default Layout;
